<template>
	<div class="layout-topbar">
		<button class="p-link layout-menu-button layout-topbar-button ml-0 mr-1" @click="onMenuToggle">
			<i class="pi pi-bars"></i>
		</button>
		<router-link to="/" class="layout-topbar-logo">
			<!-- <img alt="Logo" :src="topbarImage()" /> -->
			<img :src="'assets/LogoDragon.png'" alt="Logo"/>
			<span>SITE</span>
		</router-link>
		<h4>Bienvenido, {{ getUsuarioLogueado?.Usuario?.Nombres.split(" ")[0]?.charAt(0).toUpperCase() + getUsuarioLogueado?.Usuario?.Nombres.split(" ")[0]?.slice(1).toLowerCase() }} {{ getUsuarioLogueado?.Usuario?.Ap_pat?.charAt(0).toUpperCase() + getUsuarioLogueado?.Usuario?.Ap_pat?.slice(1).toLowerCase() }}</h4>
		<button class="p-link layout-topbar-menu-button layout-topbar-button"
			v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', 
			leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true}">
			<i class="pi pi-ellipsis-v"></i>
		</button>
		<ul class="layout-topbar-menu hidden lg:flex origin-top">
			<!-- <li>
				<button class="p-link layout-topbar-button">
					<i class="pi pi-calendar"></i>
					<span>Events</span>
				</button>
			</li>
			<li>
				<button class="p-link layout-topbar-button">
					<i class="pi pi-cog"></i>
					<span>Settings</span>
				</button>

			</li> -->
			<li>
				<Button type="button" class="p-button-text layout-topbar-button"
				@click="toggle" aria-haspopup="true" aria-controls="overlay_menu" 
				>
					<i class="pi pi-ellipsis-v"></i>
				</Button>
			</li>
		</ul>

		<!-- <OverlayPanel ref="op">
			<img src="demo/images/nature/nature1.jpg" alt="Nature Image">
		</OverlayPanel> -->
		<Menu ref="menu" id="overlay_menu" :model="items" class="w-full md:w-15rem" :popup="true">
			<template #end>
				<button v-ripple class="relative overflow-hidden w-full p-link flex align-items-center p-2 pl-3 text-color hover:surface-200 border-noround">
					<Avatar image="/assets/persona.png" class="mr-2" shape="circle" />
					<span class="inline-flex flex-column">
						<span class="font-bold">{{ getUsuarioLogueado?.Usuario?.Nombres.split(" ")[0]?.charAt(0).toUpperCase() + getUsuarioLogueado?.Usuario?.Nombres.split(" ")[0]?.slice(1).toLowerCase() }} {{ getUsuarioLogueado?.Usuario?.Ap_pat?.charAt(0).toUpperCase() + getUsuarioLogueado?.Usuario?.Ap_pat?.slice(1).toLowerCase() }}</span>
						<span class="text-sm">{{getUsuarioLogueado?.Empleado_ci?.Puesto}}</span>
					</span>
				</button>
			</template>
		</Menu>
	</div>
		<!-- <AppConfig :layoutMode="layoutMode" @layout-change="onLayoutChange" v-show="getUsuarioLogueado"/> -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import AppConfig from './AppConfig.vue';

export default {
	emits: ['menu-toggle','topbar-menu-toggle'],
	data(){
		return {
			items: [
                // {
                //     label: 'Documents',
                //     items: [
                //         {
                //             label: 'New',
                //             icon: 'pi pi-plus',
                //             shortcut: '⌘+N'
                //         },
                //         {
                //             label: 'Search',
                //             icon: 'pi pi-search',
                //             shortcut: '⌘+S'
                //         }
                //     ]
                // },
                {
                    label: 'Perfil',
                    items: [
                        // {
                        //     label: 'Settings',
                        //     icon: 'pi pi-cog',
                        //     shortcut: '⌘+O'
                        // },
                        // {
                        //     label: 'Messages',
                        //     icon: 'pi pi-inbox',
                        //     badge: 2
                        // },
                        {
                            label: 'Cerrar sesión',
                            icon: 'pi pi-sign-out',
							command : this.cerrarSesion
                        }
                    ]
                },
            ]
            // layoutMode: 'static',
		};
	},
	components: {
        // 'AppConfig': AppConfig,
    },
    methods: {
		// onLayoutChange(layoutMode) {
		// 	this.layoutMode = layoutMode;
		// },
		...mapActions(["setUsuarioLogueado"]),
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
        },
		onTopbarMenuToggle(event) {
            this.$emit('topbar-menu-toggle', event);
        },
		topbarImage() {
			return this.$appState.darkTheme ? 'images/logo-white.svg' : 'images/logo-dark.svg';
		},
		cerrarSesion() {
			this.setUsuarioLogueado(null);
			this.$router.push("/login");
			this.expanded = false;
		},
		toggle(event) {
			this.$refs.menu.toggle(event);
		},
    },
	computed: {
		...mapGetters(['getUsuarioLogueado']),
		darkTheme() {
			return this.$appState.darkTheme;
		},

	}
}
</script>